import React, {useEffect} from 'react';
import ReactDOM from "react-dom";
import Datamodal, {COMPACT_MODAL_TYPES, SIDE_PANEL_MODAL_TYPES} from "components/modal/dataModal";
import Modalstructure from "components/modal/components/structure";
import UseContext from "hooks/useContext";

const Index = () => {
    const {modalShow, setModalShow, modalType, sidePanelHasChanges, setSidePanelHasChanges}=UseContext()

    // Every panel starts clean: a panel left with changes must not block the next one.
    useEffect(() => {
        setSidePanelHasChanges(false)
    }, [modalShow, modalType, setSidePanelHasChanges])

    if(!modalShow) return null

    const closeOnOutsideClick = () => {
        if (!sidePanelHasChanges) setModalShow(false)
    }

    return ReactDOM.createPortal(
        <Modalstructure
            isShowing={modalShow}
            placement={SIDE_PANEL_MODAL_TYPES.has(modalType) ? 'right' : 'center'}
            size={COMPACT_MODAL_TYPES.has(modalType) ? 'compact' : 'default'}
            onOutsideClick={closeOnOutsideClick}
        >
            <Datamodal/>
        </Modalstructure>
        , document.getElementById('root-portal'));
};

export default Index;